import { trackCustomEvent } from '@utils/statistics/clientStatistics';
import { mainMenuItemClickEvent } from '@utils/statistics/customEvents';
import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
import { Link as StyledMenuLink, ListItem } from './MenuItem.styles';

type Props = {
    route: string;
    accessKey: string;
    type: string;
    text: string;
    index: number;
    currentPath: string;
};

export const MenuItem = ({ route, accessKey, type, text, index, currentPath }: Props) => {
    const classes = classNames(
        { 'play_is-active': route === currentPath }, // For integration tests
        `lp_pos${index + 1}`
    );

    return (
        <ListItem type={type} data-rt="menu-item">
            <Link href={route} passHref>
                <StyledMenuLink
                    isActive={route === currentPath}
                    className={classes}
                    accessKey={accessKey}
                    onClick={() => {
                        trackCustomEvent(mainMenuItemClickEvent(text, index));
                    }}
                >
                    {text}
                </StyledMenuLink>
            </Link>
        </ListItem>
    );
};

export default MenuItem;
